import { motion } from "framer-motion";
import { Trophy } from "lucide-react";

const trophies = Array.from({ length: 6 }, (_, i) => i);

export default function ConventionSection() {
  return (
    <section
      id="convention"
      data-testid="convention-section"
      className="py-24 md:py-32 bg-[#060606] relative overflow-hidden"
    >
      {/* Gold glow background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(201,168,76,0.05)_0%,transparent_70%)]" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="section-label text-center block">Auszeichnungen</span>
          <h2 className="font-cormorant text-5xl md:text-7xl lg:text-8xl italic text-[#F0F0F0] leading-none mb-4">
            6× ausgezeichnet.
          </h2>
          <p className="text-[#888888] text-sm md:text-base font-outfit tracking-[0.15em] mb-16">
            Tattoo Convention Meckenheim · 2025
          </p>
        </motion.div>

        {/* Trophy Icons */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mb-16">
          {trophies.map((_, i) => (
            <motion.div
              key={i}
              data-testid={`trophy-${i + 1}`}
              className="flex flex-col items-center gap-2"
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12, duration: 0.6, ease: "easeOut" }}
            >
              <div className="w-16 h-16 md:w-20 md:h-20 border border-[#C9A84C]/40 flex items-center justify-center bg-[#141414] group hover:border-[#C9A84C] hover:shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all duration-300">
                <Trophy
                  size={32}
                  className="text-[#C9A84C] group-hover:scale-110 transition-transform duration-300"
                  strokeWidth={1.5}
                />
              </div>
              <span className="text-[#C9A84C] text-xs tracking-[0.15em] font-outfit">
                #{i + 1}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Decorative line */}
        <motion.div
          className="flex items-center gap-6 mb-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#5A4A1A] to-transparent" />
          <span className="text-[#C9A84C]">
            <Trophy size={16} strokeWidth={1.5} />
          </span>
          <div className="flex-1 h-px bg-gradient-to-r from-transparent via-[#5A4A1A] to-transparent" />
        </motion.div>

        {/* Quote Block */}
        <motion.blockquote
          className="max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 1.0, duration: 0.7 }}
        >
          <p className="font-cormorant text-2xl md:text-3xl italic text-[#F0F0F0] leading-relaxed mb-4">
            "Kunst auf der Haut ist unsere Leidenschaft — und die Auszeichnungen bestätigen unseren Anspruch."
          </p>
          <footer className="text-[#888888] text-xs tracking-[0.2em] uppercase font-outfit">
            Franco · Inhaber Royal Tattoo
          </footer>
        </motion.blockquote>
      </div>
    </section>
  );
}
